module.exports = __webpack_public_path__ + "static/media/lang8.61e9d1db.mp3";